module.exports = __webpack_public_path__ + "media/images/user4-128x128-d5120b0bde80ecd71cb1a8531e335598.jpg";